export default __webpack_public_path__ + "static/walls-house-d6d455ef732728ab9bfb5a653956a4f0.png";